import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'

// plugins
import '@/plugins/bootstrap-vue'
import '@/plugins/font-awesome'
import '@/plugins/vee-validate'
import '@/plugins/vue-clipboard'
import '@/plugins/vue-calendar'
import '@/plugins/axios'
import '@/plugins/lodash'

import * as fb from '@/plugins/firebase'

import App from './App.vue'
import {router} from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(require('vue-moment'));

let app
fb.auth.onAuthStateChanged(() => {
    if (!app) {
        app = new Vue({
            router,
            store,
            //i18n,
            render: h => h(App)
        }).$mount('#app')
    }
})